export const LANGUAGES = [
  // 🇮🇳 Indian Scheduled Languages (22)
  "Assamese",
  "Bengali",
  "Bodo",
  "Dogri",
  "Gujarati",
  "Hindi",
  "Kannada",
  "Kashmiri",
  "Konkani",
  "Maithili",
  "Malayalam",
  "Manipuri",
  "Marathi",
  "Nepali",
  "Odia",
  "Punjabi",
  "Sanskrit",
  "Santali",
  "Sindhi",
  "Tamil",
  "Telugu",
  "Urdu",

  // 🇮🇳 Other Major Indian Languages / Dialects
  "Tulu",
  "Bhojpuri",
  "Magahi",
  "Haryanvi",
  "Rajasthani",
  "Chhattisgarhi",
  "Marwari",
  "Garhwali",
  "Kumaoni",
  "Awadhi",
  "Mizo",
  "Tripuri",
  "Nagamese",
  "Bhili",
  "Gondi",
  "Sourashtra",
  "Angika",
  "Ladakhi",
  "Pali",
  "Khasi",
  "Konkani (Goa Dialect)",
  "Kodava",
  "Meitei",
  "Santhali (Regional Variants)",

  // 🌐 International Languages
  "English",
  "Arabic",
  "Chinese (Mandarin)",
  "Chinese (Cantonese)",
  "French",
  "German",
  "Japanese",
  "Korean",
  "Portuguese",
  "Brazilian Portuguese",
  "Russian",
  "Spanish",
  "Latin American Spanish",
  "Italian",
  "Dutch",
  "Persian (Farsi)",
  "Turkish",
  "Greek",
  "Thai",
  "Vietnamese",
  "Indonesian (Bahasa)",
  "Malay",
  "Hebrew",
  "Swedish",
  "Finnish",
  "Norwegian",
  "Danish",
  "Polish",
  "Czech",
  "Slovak",
  "Hungarian",
  "Romanian",
  "Ukrainian",
  "Bulgarian",
  "Croatian",
  "Serbian",
  "Bosnian",
  "Slovenian",
  "Afrikaans",
  "Swahili",
  "Zulu",
  "Xhosa",
  "Filipino (Tagalog)",
  "Cebuano",
  "Burmese",
  "Sinhala",
  "Tibetan",
  "Mongolian",
  "Khmer (Cambodian)",
  "Lao",
  "Pashto",
  "Urdu (Regional Dialects)",
  "Uzbek",
  "Kazakh",
  "Kyrgyz",
  "Tajik",
  "Armenian",
  "Georgian",
  "Amharic",
  "Somali",
  "Nepali (Regional Variants)",
  "Hausa",
  "Igbo",
  "Yoruba",
  "Berber (Tamazight)",
  "Quechua",
  "Guarani",
  "Nahuatl",

  // Generic Option
  "Others",
];
